import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";

const navItems = [
  { label: "Services", href: "#services" },
  { label: "AI System", href: "#ai-system" },
  { label: "Why Us", href: "#why" },
  { label: "Process", href: "#process" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 lg:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo">
          <Logo />
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="px-4 py-2 text-sm text-zinc-400 hover:text-white transition-colors relative group"
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {item.label}
              <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-[#39FF14] scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:2149838371"
            className="flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition"
            data-testid="nav-phone"
          >
            <Phone className="w-4 h-4 text-[#39FF14]" />
            <span className="font-mono">214-983-8371</span>
          </a>
          <a
            href="https://cal.com/erik-carlson/secret"
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-2.5 rounded-full bg-[#39FF14] text-black font-semibold text-sm hover:bg-white transition-all hover:shadow-[0_0_24px_rgba(57,255,20,0.45)]"
            data-testid="nav-cta-button"
          >
            Book Strategy Call
          </a>
        </div>

        <button
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden p-2 text-white"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#050505]/95 backdrop-blur-xl border-b border-white/5">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-2">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-2 py-2.5 text-zinc-300 hover:text-white"
                data-testid={`nav-mobile-link-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="https://cal.com/erik-carlson/secret"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 px-5 py-3 rounded-full bg-[#39FF14] text-black font-semibold text-center"
              data-testid="nav-mobile-cta"
            >
              Book Strategy Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
